import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const SalesPage = lazy(() => import('./SalesPage'));

const SalesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Sales,
  routes: [
    {
      path: 'sales',
      element: <SalesPage />,
    },
  ],
};

export default SalesConfig;
